'use client'

import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { popModal } from '@/components/modals'

interface ConfirmationModalProps {
  title: string
  message: string
  confirmLabel: string
  cancelLabel: string
  variant?: 'default' | 'danger' | 'warning'
  onConfirm: () => void
  onCancel?: () => void
}

export default function ConfirmationModal({
  title,
  message,
  confirmLabel,
  cancelLabel,
  variant = 'default',
  onConfirm,
  onCancel,
}: ConfirmationModalProps) {
  const handleConfirm = () => {
    onConfirm()
    popModal()
  }

  const handleCancel = () => {
    onCancel?.()
    popModal()
  }

  // Map variant to button variant
  const buttonVariant = {
    default: 'default',
    danger: 'destructive',
    warning: 'secondary',
  }[variant] as 'default' | 'destructive' | 'secondary'

  return (
    <DialogContent className="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{message}</DialogDescription>
      </DialogHeader>
      <DialogFooter className="mt-6 gap-2 sm:gap-0">
        <Button type="button" variant="outline" onClick={handleCancel}>
          {cancelLabel}
        </Button>
        <Button type="button" variant={buttonVariant} onClick={handleConfirm}>
          {confirmLabel}
        </Button>
      </DialogFooter>
    </DialogContent>
  )
}
